<script lang="ts">
	import CTABanner from './CTABanner.svelte';
</script>

<CTABanner
	title="Help shape the future of edge infrastructure."
	titleHtml="Help shape the future of edge infrastructure."
/>
